import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useBusinessStatus = () => {
  const { t } = useTranslation();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [status, setStatus] = useState(t('closed'));

  const updateStatus = useCallback((time) => {
    const currentHour = time.getHours();
    const currentDay = time.getDay();

    // Business hours are Monday to Friday, 8:30 AM to 5:30 PM
    if (
      currentDay >= 1 && // Monday
      currentDay <= 5 && // Friday
      (currentHour > 8 || (currentHour === 8 && time.getMinutes() >= 30)) &&
      currentHour < 17
    ) {
      setStatus(t('open'));
    } else {
      setStatus(t('closed'));
    }
  }, [t]);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      setCurrentTime(now);
      updateStatus(now);
    }, 1000);

    updateStatus(new Date());

    return () => clearInterval(timer);
  }, [updateStatus]);

  return { currentTime, status };
};

export default useBusinessStatus;
